import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardHome from './DashboardHome';
import WhatsAppControl from './WhatsAppControl';
import MessagesPanel from './MessagesPanel';
import Settings from './Settings';

const Dashboard = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardHome />} />
      <Route path="/whatsapp" element={<WhatsAppControl />} />
      <Route path="/messages" element={<MessagesPanel />} />
      <Route path="/settings" element={<Settings />} />
    </Routes>
  );
};

export default Dashboard;

